import { StyleSheet } from 'react-native';

const baseStyles = {
    container: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        flex: 1,
        width: '100%',
        height: '100%'
    },
    innerContainer: {
        alignItems: 'center',
        flexDirection: 'column-reverse',
        justifyContent: 'center',
        height: '100%'
    },
    iconClose: {
        position: 'absolute',
        top: '3%',
        right: '3%'
    },
    backgroundContainer: {
        backgroundColor: 'rgba(255, 0, 0, .15)'
    }
};

export default StyleSheet.create(baseStyles as any);
